import { api } from 'app/utils/api/helpers'

export const addPropertyOfferDisclosureAttachments = (
  agencyGUID,
  offerGUID,
  formData,
) => {
  return api.post(
    `sm/agency/${agencyGUID}/offer/${offerGUID}/propertydisclosureattachments`,
    formData,
  )
}
